module.exports = __webpack_public_path__ + "img/muyingchongwu.f001a84d.png";